import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux';
import axios from 'axios';
import Dropdown from 'react-bootstrap/Dropdown';
import LottiePlayer from "lottie-react";
import nodatafound from '../../../assets/animationicons/nodatafound.json'
import { CancelIcon, SearchesCIcon, SortIcon } from '../../../SvgIconsData';
import Filter from '../../Filter/Filter';
import ProPopup from '../../layouts/ProPopup';
import { AZIcon, CloseIcon, OldSortIcon, ZAIcon } from '../../../assets/icons/iconshere';

const GroupFileTab = ({ setGroupLength, search="", setSearch="", groupTypesList=[], onSelect }) => {
    var params = useParams();
    const userData = useSelector((state) => state.userSlice);
    const configData = useSelector((state) => state.configSlice);
    var { groupId } = params;
    const [groupsList, setGroupsList] = useState([]);
    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
    const [filterOptions, setFilterOptions] = useState([]);
    const [sorting, setsorting] = useState(1)

    const [openPro, setOpenPro] = useState(false);
    const [userPlan, setUserPlan] = useState(null);
  
    useEffect(() => {
      userData?.plans?.data && setUserPlan(userData.plans.data);
    }, [userData]);

    var fetchGroups = async () => {
        try {
            setGroupLength(0)
            var { data } = await axios.get(`${configData.config.UNO_URL}/api/user/group/list/${groupId}`, {
                headers: {
                    'Authorization': `Bearer ${userData.token}`
                }
            });

            setGroupsList(data.data)
            setGroupLength(data.data.length)
        } catch (error) {

            console.log(error)
        }
    }

    useEffect(() => {
        fetchGroups();
    }, [groupId]);

    useEffect(() => {
        let formattedAllocationData = {
            name: "Group type",
            tags:  (groupTypesList.map((e) => ({id : e.id , name : e.name}))).sort((c, d) => c.name.localeCompare(d.name))
        }
        setFilterOptions([formattedAllocationData]);

    }, [groupTypesList]);


    const filterCourses = (e => {
        if (search.length && !e.name.toLowerCase().includes(search.toLowerCase())) return false;
        if (selectedCheckboxes.length && !(selectedCheckboxes.map((f=> f.id)).includes(e.typeId))) return false;
         
        return true;
    });
    let filteredList = groupsList.filter(filterCourses);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const handleDropdownToggle = () => {
        setDropdownOpen(!dropdownOpen);
      };

      const handleCancelTag = (item) => {
        setSelectedCheckboxes((prevSelected) => prevSelected.filter((selectedItem) => selectedItem !== item));
     };

     return (
        <>
                <div className='row pt-4 mt-3'>
                    <div className='col-md-12 d-flex align-items-center justify-content-end'>
                            <form className=" app-search app-search1 d-flex justify-content-start me-2">
                                <div className="position-relative">
                                    <SearchesCIcon />
                                   {search.length > 0 && <span className='searchiconcancel' onClick={()=>setSearch("")} >
                                    <CancelIcon />
                                    </span>}
                                    <input
                                        type="text"
                                        name="searchName"
                                        className="form-control"
                                        placeholder="Search"
                                        autoComplete="off"
                                        value={search}
                                        onChange={(e)=>setSearch(e.target.value)}
                                    />
                                </div>
                            </form>

                            <Filter
                                selectedCheckboxes={selectedCheckboxes}
                                setSelectedCheckboxes={setSelectedCheckboxes}
                                filterOptions={filterOptions}
                            />
                    </div>
                </div>
         
                {selectedCheckboxes.length > 0 && 
                    <div className='filerlist mt-3'>
                    <span>Filters:</span> 
                        {selectedCheckboxes.map(f =>{
                            return(
                                <span className='filtertag'>
                                    {f.name} 
                                    <span onClick={()=>handleCancelTag(f)} ><CloseIcon/></span>
                                </span>
                            )
                    })}
                    <span className='filtertag clear' onClick={()=> setSelectedCheckboxes([])} style={{cursor:"pointer"}}>
                        Clear all
                    </span>
                    </div>
                         }
                            
                <div className='courses-parent usergrouplist'>          
                        { filteredList.length > 0 ? 
                            <div className="course-tiles mt-3">
                                {filteredList.map((group, index) => (
                                    <div className="tilecard p-0 mb-3" key={index} onClick={() => {
                                        if (userPlan && userPlan?.teamDashboard?.group) {
                                          onSelect(group);
                                        } else {
                                          setOpenPro(true);
                                        }
                                      }}>
                                        <div className='groupcardesign' key={group.id}>
                                            {group.avatar ? (
                                                <div className='avatarimg'>
                                                    <img src={group.avatar} alt={`Avatar for ${group.name}`} title={group.name} />
                                                </div>
                                            ) : (
                                                <div className='initials-placeholder'>
                                                    {group?.name?.split(' ').map(word => word[0]).slice(0, 2).join('')}
                                                </div>
                                            )}
                                            <h6 className='groupname'>{group.name}</h6>
                                            <div className="groupusercount">
                                                <p>{group.groups} Sub-Groups  <span className='mx-1'>|</span></p>
                                                <p> {group.users} Users  </p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        :
                        <div className="text-center mt-5">
                            <LottiePlayer
                                animationData={nodatafound}
                                style={{ height: 200 }}
                                autoplay
                                loop
                            />
                            <h5>No Groups Found</h5>
                        </div>
                        }
                </div>

                <ProPopup openPro={openPro} setOpenPro={setOpenPro} />                


        </>
    )
}

export default GroupFileTab
